import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://farm.my-it.pl/api';
console.log('API_BASE_URL:', API_BASE_URL);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('Environment variables:', process.env);
console.log('Full API URL for login:', API_BASE_URL + '/auth/login');
console.log('Backend is running on port 5001');

// Tworzenie instancji axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor dla requestów - dodawanie tokenu
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Nie ustawiaj Content-Type dla multipart/form-data - przeglądarka ustawi to automatycznie z boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    // Logowanie dla debugowania
    console.log('🚀 Axios Request:', {
      method: config.method,
      url: config.url,
      baseURL: config.baseURL,
      fullURL: `${config.baseURL}${config.url}`,
      hasToken: !!token,
      hasFormData: config.data instanceof FormData
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor dla odpowiedzi - obsługa błędów autentykacji
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Loguj tylko błędy inne niż 401 (401 jest normalne przy sprawdzaniu autentykacji)
    if (error.response?.status !== 401) {
      console.error('❌ Axios Error:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        url: error.config?.url,
        baseURL: error.config?.baseURL,
        fullURL: `${error.config?.baseURL}${error.config?.url}`,
        responseData: error.response?.data
      });
    }
    
    if (error.response?.status === 401) {
      // Token wygasł lub jest nieprawidłowy
      // Nie przekierowuj automatycznie - pozwól komponentom obsłużyć to
      const token = localStorage.getItem('token');
      if (token) {
        // Tylko usuń token jeśli był ustawiony (nie przy pierwszym sprawdzeniu)
        localStorage.removeItem('token');
        // Przekieruj tylko jeśli nie jesteśmy już na stronie logowania
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
